import script from "./PreSportsSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./PreSportsSlider.vue?vue&type=script&setup=true&lang=js"

import "./PreSportsSlider.vue?vue&type=style&index=0&id=359613a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-359613a5"]])

export default __exports__